<template>
  <div class="service-role-setting">

    <transition name="fade-transform" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>


  export default {
    name: 'service-role-setting',

  }
</script>

<style lang="scss">
</style>
